var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h3", [
      _vm._v(_vm._s(_vm.$t("InvestmentReport.Finances.Funding.Title")))
    ]),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Array")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(_vm._s(_vm.$t("InvestmentReport.Finances.Funding.FundingICT")))
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        _vm._s(
          _vm.$t("InvestmentReport.Finances.Funding.FundingICT_Instructions")
        )
      )
    ]),
    _vm._v(" "),
    _c("div", [
      _c("ul", [
        _c("li", [
          _c("b", [
            _vm._v(
              _vm._s(
                _vm.$t("InvestmentReport.Finances.Funding.SelfCoveredFunding")
              )
            )
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _c("b", [
            _vm._v(
              _vm._s(
                _vm.$t("InvestmentReport.Finances.Funding.OtherGovernmentAid")
              )
            )
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _c("b", [
            _vm._v(
              _vm._s(_vm.$t("InvestmentReport.Finances.Funding.AppliedAid"))
            )
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "ml-3" }, [
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.FurtherDescription")))]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(
          _vm._s(
            _vm.$t(
              "InvestmentReport.Finances.Funding.SelfCoveredFunding_Details"
            )
          )
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "ml-3" }, [
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.FurtherDescription")))]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(
          _vm._s(
            _vm.$t(
              "InvestmentReport.Finances.Funding.OtherGovernmentAid_Details"
            )
          )
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          _vm._s(
            _vm.$t(
              "InvestmentReport.Finances.Funding.OtherGovernmentAid_Details_Instructions"
            )
          )
        )
      ])
    ]),
    _vm._v(" "),
    _c("h3", [
      _vm._v(_vm._s(_vm.$t("InvestmentReport.Finances.Expenses.Title")))
    ]),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(
        _vm._s(
          _vm.$t(
            "InvestmentReport.Finances.Expenses.PersonnelExpenses.HasPersonnel"
          )
        )
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        _vm._s(
          _vm.$t(
            "InvestmentReport.Finances.Expenses.PersonnelExpenses.HasPersonnel_Instructions"
          )
        )
      )
    ]),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Array")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(
        _vm._s(
          _vm.$t(
            "InvestmentReport.Finances.Expenses.PersonnelExpenses.SalaryItems.Title"
          )
        )
      )
    ]),
    _vm._v(" "),
    _c("ul", [
      _c("li", [
        _c("b", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "InvestmentReport.Finances.Expenses.PersonnelExpenses.SalaryItems.JobTitle"
              )
            )
          )
        ]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "InvestmentReport.Finances.Expenses.PersonnelExpenses.SalaryItems.JobTitle_Instructions"
              )
            )
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("b", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "InvestmentReport.Finances.Expenses.PersonnelExpenses.SalaryItems.Description"
              )
            )
          )
        ]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "InvestmentReport.Finances.Expenses.PersonnelExpenses.SalaryItems.Description_Instructions"
              )
            )
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("b", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "InvestmentReport.Finances.Expenses.PersonnelExpenses.SalaryItems.GrossSalary"
              )
            )
          )
        ]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "InvestmentReport.Finances.Expenses.PersonnelExpenses.SalaryItems.GrossSalary_Instructions"
              )
            )
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("b", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "InvestmentReport.Finances.Expenses.PersonnelExpenses.SalaryItems.WorkingHours"
              )
            )
          )
        ]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "InvestmentReport.Finances.Expenses.PersonnelExpenses.SalaryItems.WorkingHours_Instructions"
              )
            )
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("b", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "InvestmentReport.Finances.Expenses.PersonnelExpenses.SalaryItems.WorkingHoursPercent"
              )
            )
          )
        ]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "InvestmentReport.Finances.Expenses.PersonnelExpenses.SalaryItems.WorkingHoursPercent_Instructions"
              )
            )
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("b", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "InvestmentReport.Finances.Expenses.PersonnelExpenses.SalaryItems.IsDivided"
              )
            )
          )
        ]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "InvestmentReport.Finances.Expenses.PersonnelExpenses.SalaryItems.IsDivided_Instructions"
              )
            )
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Array")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(
        _vm._s(
          _vm.$t(
            "InvestmentReport.Finances.Expenses.PersonnelExpenses.YearlyPersonnelExpenses.Title"
          )
        )
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        _vm._s(
          _vm.$t(
            "InvestmentReport.Finances.Expenses.PersonnelExpenses.YearlyPersonnelExpenses.Title_Instructions"
          )
        )
      )
    ]),
    _vm._v(" "),
    _c("ul", [
      _c("li", [
        _c("b", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "InvestmentReport.Finances.Expenses.PersonnelExpenses.YearlyPersonnelExpenses.Salaries"
              )
            )
          )
        ]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "InvestmentReport.Finances.Expenses.PersonnelExpenses.YearlyPersonnelExpenses.Salaries_Instructions"
              )
            )
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("b", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "InvestmentReport.Finances.Expenses.PersonnelExpenses.YearlyPersonnelExpenses.Rewards"
              )
            )
          )
        ]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "InvestmentReport.Finances.Expenses.PersonnelExpenses.YearlyPersonnelExpenses.Rewards_Instructions"
              )
            )
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("b", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "InvestmentReport.Finances.Expenses.PersonnelExpenses.YearlyPersonnelExpenses.HourlyWages"
              )
            )
          )
        ]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "InvestmentReport.Finances.Expenses.PersonnelExpenses.YearlyPersonnelExpenses.HourlyWages_Instructions"
              )
            )
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("b", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "InvestmentReport.Finances.Expenses.PersonnelExpenses.YearlyPersonnelExpenses.HolidayPays"
              )
            )
          )
        ]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "InvestmentReport.Finances.Expenses.PersonnelExpenses.YearlyPersonnelExpenses.HolidayPays_Instructions"
              )
            )
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("b", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "InvestmentReport.Finances.Expenses.PersonnelExpenses.YearlyPersonnelExpenses.Pensions"
              )
            )
          )
        ]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "InvestmentReport.Finances.Expenses.PersonnelExpenses.YearlyPersonnelExpenses.Pensions_Instructions"
              )
            )
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("b", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "InvestmentReport.Finances.Expenses.PersonnelExpenses.YearlyPersonnelExpenses.StatutoryPersonnelCosts"
              )
            )
          )
        ]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "InvestmentReport.Finances.Expenses.PersonnelExpenses.YearlyPersonnelExpenses.StatutoryPersonnelCosts_Instructions"
              )
            )
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("b", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "InvestmentReport.Finances.Expenses.PersonnelExpenses.YearlyPersonnelExpenses.VoluntaryStaffCosts"
              )
            )
          )
        ]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "InvestmentReport.Finances.Expenses.PersonnelExpenses.YearlyPersonnelExpenses.VoluntaryStaffCosts_Instructions"
              )
            )
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Array")))]),
    _vm._v(" "),
    _vm.isFinalReport
      ? _c("p", { staticClass: "question" }, [
          _vm._v(
            _vm._s(
              _vm.$t(
                "InvestmentReport.Finances.Premises.ProjectExpenses.FinalReportTitle"
              )
            )
          )
        ])
      : _c("p", { staticClass: "question" }, [
          _vm._v(
            _vm._s(
              _vm.$t(
                "InvestmentReport.Finances.Premises.ProjectExpenses.BudgetaryEstimateTitle"
              )
            )
          )
        ]),
    _vm._v(" "),
    _vm.isFinalReport
      ? _c("p", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "InvestmentReport.Finances.Premises.ProjectExpenses.FinalReportTitle_Instructions"
              )
            )
          )
        ])
      : _c("p", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "InvestmentReport.Finances.Premises.ProjectExpenses.BudgetaryEstimateTitle_Instructions"
              )
            )
          )
        ]),
    _vm._v(" "),
    _c("ul", [
      _c("li", [
        _c("b", [
          _vm._v(
            _vm._s(
              _vm.$t("InvestmentReport.Finances.ICT.ProjectExpenses.Machines")
            )
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("b", [
          _vm._v(
            _vm._s(
              _vm.$t("InvestmentReport.Finances.ICT.ProjectExpenses.Software")
            )
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("b", [
          _vm._v(
            _vm._s(
              _vm.$t("InvestmentReport.Finances.ICT.ProjectExpenses.Startup")
            )
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("b", [
          _vm._v(
            _vm._s(
              _vm.$t("InvestmentReport.Finances.ICT.ProjectExpenses.Materials")
            )
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("b", [
          _vm._v(
            _vm._s(
              _vm.$t("InvestmentReport.Finances.ICT.ProjectExpenses.Support")
            )
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("b", [
          _vm._v(
            _vm._s(
              _vm.$t("InvestmentReport.Finances.ICT.ProjectExpenses.Training")
            )
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("b", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "InvestmentReport.Finances.ICT.ProjectExpenses.Consultation"
              )
            )
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("b", [
          _vm._v(
            _vm._s(
              _vm.$t("InvestmentReport.Finances.ICT.ProjectExpenses.Other")
            )
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("b", [
          _vm._v(
            _vm._s(
              _vm.$t("InvestmentReport.Finances.ICT.ProjectExpenses.Personnel")
            )
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Array")))]),
    _vm._v(" "),
    _c("h3", { staticClass: "mt-0" }, [
      _vm._v(_vm._s(_vm.$t("InvestmentReport.Finances.Results.Title")))
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        _vm._s(_vm.$t("InvestmentReport.Finances.Results.Title_Instructions"))
      )
    ]),
    _vm._v(" "),
    _c("ul", [
      _c("li", [
        _c("b", [
          _vm._v(_vm._s(_vm.$t("InvestmentReport.Finances.Results.Funding")))
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("b", [
          _vm._v(_vm._s(_vm.$t("InvestmentReport.Finances.Results.Expenses")))
        ]),
        _vm._v(" "),
        _c("div", [_vm._v(_vm._s(_vm.$t("Validation.ComputedAmountIsZero")))])
      ])
    ]),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Array")))]),
    _vm._v(" "),
    _c("h3", { staticClass: "mt-0" }, [
      _vm._v(_vm._s(_vm.$t("InvestmentReport.Finances.Attachments.Title")))
    ]),
    _vm._v(" "),
    _c("div", [
      _c("ul", [
        _c("li", [
          _c("b", [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "InvestmentReport.Finances.Attachments.IncomeStatementOrBalanceSheet"
                )
              )
            )
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _c("b", [
            _vm._v(
              _vm._s(
                _vm.$t("InvestmentReport.Finances.Attachments.GeneralLedger")
              )
            )
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _c("b", [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "InvestmentReport.Finances.Attachments.CompetitiveTenderings"
                )
              )
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }